/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_To_CollectInputs */

const en_features_to_collect = /** @type {(inputs: Features_To_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To collect`)
};

const pl_features_to_collect = /** @type {(inputs: Features_To_CollectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do pobrania`)
};

/**
* | output |
* | --- |
* | "To collect" |
*
* @param {Features_To_CollectInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_to_collect = /** @type {((inputs?: Features_To_CollectInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_To_CollectInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_to_collect(inputs)
	return en_features_to_collect(inputs)
});